import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import styles from "./Auth.module.css";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const nav = useNavigate();

  const submit = async (e: any) => {
    e.preventDefault();
    try {
      const r = await axios.post(
        (process.env.REACT_APP_API_URL || "http://localhost:8080") +
          "/api/auth/login",
        { email, password }
      );

      localStorage.setItem("bni_token", r.data.token);
      localStorage.setItem("bni_user", JSON.stringify(r.data.user));

      if (r.data.user.role === "SUPER_ADMIN") {
        nav("/admin");
      } else {
        nav("/");
      }

      window.location.reload();
    } catch (err: any) {
      alert(err.response?.data?.message || "Login failed");
    }
  };

  return (
    <div className={styles.authWrapper}>
      <div className={styles.card}>
        <h2 className={styles.title}>Welcome Back</h2>
        <p className={styles.subtitle}>Login to continue your journey</p>

        <form onSubmit={submit} className={styles.form}>
          <div className={styles.inputGroup}>
            <label>Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
            />
          </div>

          <div className={styles.inputGroup}>
            <label>Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
            />
          </div>

          <button type="submit" className={styles.btnPrimary}>
            Login
          </button>

          <div className={styles.footerText}>
            Don’t have an account? <Link to="/auth/signup">Create Account</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
